(() => {
  const trackerVersion = '3.1.0';
  const measurementVersion = 'viewport-active-v1';
  const courseIdsByHandle = {
    'fusion-der-ultimative-einsteiger-video-kurs': '8609643266313',
    'fusion-360-mesh-bearbeitung-3d-scan-und-stl-digitaler-video-kurs': '9401608700169',
    '3d-druck-verstehen-und-beherrschen': '15574336831753',
  };
  const configElement = document.getElementById('mm-conversion-config');
  if (!configElement || window.Shopify?.designMode || window.mmConversionTrackerInitialized) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    return;
  }
  const isHomepage = config.page_type === 'index';
  if (!config.product?.id && !isHomepage) return;
  window.mmConversionTrackerInitialized = true;

  const attributionKey = 'mm_attribution_v1';
  const maxPendingEvents = 100;
  const maxPublishAttempts = 3;
  const pendingEvents = [];
  const seenSections = new Set();
  const activeSections = new Map();
  const confirmedCartOperations = new Set();
  const checkoutFlowOperations = new Set();
  const paypalViews = new Set();
  const klarnaRecords = new Map();
  const performanceObservers = [];
  let analyticsAllowed = false;
  let marketingAllowed = false;
  let consentEpoch = 0;
  let consentEventState = {};
  let syncingConsent = false;
  let privacyLoadRequested = false;
  let nextPrivacyLoadAt = 0;
  let collectionActive = false;
  let pageViewTracked = false;
  let sectionObserver;
  let vitalsTimer;
  let inFlight;
  let publishingSync = false;
  let documentEventId = '';
  let eventCounter = 0;
  let lastCtaAt = 0;
  let lastPaypalInfoAt = -Infinity;
  let paypalInfoCounter = 0;
  let klarnaViewTracked = false;
  let lastKlarnaInfoAt = -Infinity;
  let klarnaInfoCounter = 0;
  let klarnaPageActive = true;
  let klarnaDeniedLatch = false;
  let vitalsPublished = false;
  const vitals = { cls: 0, inp: 0, lcp: 0 };

  const compactText = (value, maxLength = 255) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, maxLength);
  const qaStorageKey = 'mm_qa_context_v1';
  let qaContext = null;
  const clearQaContext = () => {
    qaContext = null;
    try { window.sessionStorage.removeItem(qaStorageKey); } catch (_) {}
  };
  const trackingQaContext = () => {
    if (!analyticsAllowed) return {};
    const params = new URLSearchParams(window.location.search);
    const candidate = params.get('mm_qa_run') || '';
    const run = /^[A-Za-z0-9_-]{1,64}$/.test(candidate) ? candidate : '';
    // Shopify can strip webPixelDebug. A valid explicit QA run is sufficient;
    // remember it only after analytics permission, across same-tab navigation.
    if (qaContext && qaContext.expires_at <= Date.now()) clearQaContext();
    if (run || params.has('webPixelDebug')) qaContext = { debug: true,
      expires_at: Date.now() + 30 * 60 * 1000, ...(run ? { qa_run: run } : {}) };
    if (!qaContext) {
      try {
        const saved = JSON.parse(window.sessionStorage.getItem(qaStorageKey) || 'null');
        if (saved?.debug === true && Number.isFinite(saved.expires_at)
          && saved.expires_at > Date.now() && saved.expires_at <= Date.now() + 30 * 60 * 1000) qaContext = { debug: true,
          expires_at: saved.expires_at,
          ...(/^[A-Za-z0-9_-]{1,64}$/.test(saved.qa_run || '') ? { qa_run: saved.qa_run } : {}) };
      } catch (_) {}
    }
    if (qaContext) {
      qaContext.expires_at = Date.now() + 30 * 60 * 1000;
      try { window.sessionStorage.setItem(qaStorageKey, JSON.stringify(qaContext)); } catch (_) {}
    }
    return qaContext ? { debug: true, ...(qaContext.qa_run ? { qa_run: qaContext.qa_run } : {}) } : { debug: false };
  };
  const clearAttribution = () => {
    try { window.sessionStorage.removeItem(attributionKey); } catch (error) {}
  };
  const nextTrackingId = () => {
    if (!documentEventId) {
      try { documentEventId = window.crypto.randomUUID(); } catch (error) {}
      if (!/^[a-zA-Z0-9-]{1,60}$/.test(documentEventId)) {
        documentEventId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
      }
    }
    eventCounter += 1;
    return `${documentEventId}:${eventCounter}`.slice(0, 80);
  };

  const productHandleFromUrl = (value) => {
    try {
      const path = new URL(value || '', window.location.origin).pathname;
      return compactText(path.split('/products/')[1]?.split('/')[0] || '', 255);
    } catch (error) {
      return '';
    }
  };

  const trackedSections = () => {
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return [];
    return Array.from(main.children).filter((element) => element.id?.startsWith('shopify-section-')
      && !element.matches('[data-mm-paypal], [data-mm-paypal-card], [data-mm-klarna-presentation]'));
  };

  const sectionDetails = (element) => {
    const section = element?.closest?.('[id^="shopify-section-"]') || element;
    if (!section?.id) return {};
    const allSections = trackedSections();
    const rawId = section.id.replace(/^shopify-section-/, '');
    const stableId = rawId.includes('__') ? rawId.split('__').slice(1).join('__') : rawId;
    const heading = section.querySelector('h1, h2, h3, [data-mm-analytics-name]');
    return {
      section_id: stableId.slice(0, 255),
      section_name: compactText(heading?.dataset?.mmAnalyticsName || heading?.textContent || stableId),
      section_index: Math.max(0, allSections.indexOf(section)),
    };
  };

  const attribution = () => {
    // Attribution has an additional marketing purpose. Do not even read URL
    // campaign values or stored attribution until both purposes are allowed.
    if (!analyticsAllowed || !marketingAllowed) return {};
    const params = new URLSearchParams(window.location.search);
    const current = {
      source: compactText(params.get('utm_source') || '', 255),
      medium: compactText(params.get('utm_medium') || '', 255),
      campaign: compactText(params.get('utm_campaign') || '', 255),
      content: compactText(params.get('utm_content') || '', 255),
      term: compactText(params.get('utm_term') || '', 255),
      gclid: compactText(params.get('gclid') || '', 255),
      gbraid: compactText(params.get('gbraid') || '', 255),
      wbraid: compactText(params.get('wbraid') || '', 255),
    };
    let stored = {};
    try {
      const parsed = JSON.parse(window.sessionStorage.getItem(attributionKey) || '{}');
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        stored = Object.fromEntries(Object.keys(current).map((key) => [key, compactText(parsed[key], 255)]));
      }
      if (Object.values(current).some(Boolean)) {
        stored = { ...stored, ...Object.fromEntries(Object.entries(current).filter(([, value]) => value)) };
        window.sessionStorage.setItem(attributionKey, JSON.stringify(stored));
      }
    } catch (error) {}
    const result = { ...stored, ...Object.fromEntries(Object.entries(current).filter(([, value]) => value)) };
    if (!result.source && (result.gclid || result.gbraid || result.wbraid)) result.source = 'google';
    if (!result.medium && (result.gclid || result.gbraid || result.wbraid)) result.medium = 'cpc';
    return result;
  };

  const baseEvent = (campaign) => {
    let referrer = '';
    try {
      referrer = document.referrer ? `${new URL(document.referrer).origin}${new URL(document.referrer).pathname}` : '';
    } catch (error) {}
    return {
      page_path: window.location.pathname.slice(0, 1024),
      page_url: `${window.location.origin}${window.location.pathname}`.slice(0, 4096),
      page_title: compactText(document.title, 512),
      product_id: String(config.product?.id || '').slice(0, 96),
      product_handle: compactText(config.product?.handle, 255),
      product_title: compactText(config.product?.title, 512),
      source: campaign.source || compactText(referrer ? new URL(referrer).hostname : 'Direkt', 255),
      medium: campaign.medium || '',
      campaign: campaign.campaign || '',
      referrer: referrer.slice(0, 4096),
      device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
      theme_id: String(config.theme?.id || window.Shopify?.theme?.id || '').slice(0, 96),
      theme_name: compactText(config.theme?.name || window.Shopify?.theme?.name, 255),
      theme_role: compactText(config.theme?.role || window.Shopify?.theme?.role, 32),
      experience_version: compactText(config.experience_version || `theme-${config.theme?.id || 'unknown'}`, 96),
      occurred_at: new Date().toISOString(),
    };
  };

  const discardPending = () => {
    consentEpoch += 1;
    pendingEvents.length = 0;
    if (inFlight?.timer) window.clearTimeout(inFlight.timer);
    inFlight = null;
  };

  const publishPending = () => {
    syncConsent();
    if (pendingEvents.some((entry) => entry.payload.section_id === 'mm-klarna-product')
      && !klarnaConsentAllowed()) discardKlarnaPending();
    if (!analyticsAllowed || inFlight || publishingSync) return;
    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function') return;
    publishingSync = true;
    try {
      while (pendingEvents.length && !inFlight) {
        syncConsent();
        if (!analyticsAllowed || !pendingEvents.length) return;
        const entry = pendingEvents[0];
        if (entry.epoch !== consentEpoch) { pendingEvents.shift(); continue; }
        if (entry.requiresMarketing && !marketingAllowed) { pendingEvents.shift(); continue; }
        if (courseMeasurement.isEvent(entry.payload.event_name) && !courseMeasurement.allowed(entry.payload.event_name)) {
          pendingEvents.shift(); continue;
        }
        entry.attempts += 1;
        try {
          const result = analytics.publish('mistermestro:conversion', entry.payload);
          const isPromise = result && typeof result.then === 'function';
          if (entry.epoch !== consentEpoch || pendingEvents[0] !== entry) {
            if (isPromise) Promise.resolve(result).catch(() => {});
            return;
          }
          if (isPromise) {
            const flight = { entry, timer: null };
            inFlight = flight;
            const settle = (success) => {
              if (inFlight !== flight) return;
              window.clearTimeout(flight.timer);
              inFlight = null;
              syncConsent();
              if (entry.epoch !== consentEpoch || pendingEvents[0] !== entry) return;
              if (success || entry.attempts >= maxPublishAttempts) pendingEvents.shift();
              if (success) publishPending();
            };
            // A broken publisher must not block all future events indefinitely.
            flight.timer = window.setTimeout(() => settle(false), 5000);
            Promise.resolve(result).then((value) => settle(value !== false), () => settle(false));
            return;
          }
          if (entry.epoch !== consentEpoch || pendingEvents[0] !== entry) return;
          if (result === false) {
            if (entry.attempts >= maxPublishAttempts) pendingEvents.shift();
            return;
          }
          pendingEvents.shift();
        } catch (error) {
          if (entry.epoch === consentEpoch && pendingEvents[0] === entry && entry.attempts >= maxPublishAttempts) pendingEvents.shift();
          return;
        }
      }
    } finally { publishingSync = false; }
  };

  const track = (eventName, details = {}, requiresMarketing = false) => {
    syncConsent();
    if (!analyticsAllowed || (requiresMarketing && !marketingAllowed)
      || pendingEvents.length >= maxPendingEvents) return false;
    if (details.section_id === 'mm-klarna-product' && !klarnaConsentAllowed()) return false;
    if (courseMeasurement.isEvent(eventName) && !courseMeasurement.allowed(eventName)) return false;
    const acquisition = attribution();
    const metadata = {
      schema_version: 2,
      tracker_version: trackerVersion,
      ...trackingQaContext(),
      utm_content: acquisition.content || '',
      utm_term: acquisition.term || '',
      gclid: acquisition.gclid || '',
      gbraid: acquisition.gbraid || '',
      wbraid: acquisition.wbraid || '',
      ...(details.metadata_json || {}),
      tracking_event_id: nextTrackingId(),
    };
    pendingEvents.push({
      payload: { ...baseEvent(acquisition), ...details, metadata_json: metadata, event_name: eventName },
      epoch: consentEpoch,
      requiresMarketing,
      attempts: 0,
    });
    publishPending();
    return true;
  };

  // Course measurement never changes media playback, cart state or consent.
  // Progress means unique seconds actually played while visible and consented,
  // not the playhead crossing a percentage after seeking.
  const courseMeasurement = (() => {
    const scope = config.page_type === 'product'
      && Object.values(courseIdsByHandle).includes(String(config.product?.id));
    const ctaSelector = 'form[data-mm-course-checkout-form="true"] button[type="submit"], '
      + 'form[data-mm-course-checkout-form="true"] input[type="submit"], [data-mm-mobile-course-cta-button]';
    const events = new Set(['cta_view', 'video_start', 'video_progress', 'video_complete']);
    const ctas = new Map(), videos = new Map(), videoHistory = new WeakMap(), players = new WeakMap(), nativeIds = new WeakMap();
    const seenCtas = new WeakSet();
    let active = true, analyticsDenied = false, marketingDenied = false, mutationObserver;
    let apiRequested = false, serial = 0;
    const allowed = (eventName = 'cta_view') => {
      if (!scope || !active || analyticsDenied || !analyticsAllowed) return false;
      try {
        const privacy = window.Shopify?.customerPrivacy;
        if (privacy?.analyticsProcessingAllowed?.() !== true) return false;
        const explicit = privacy.currentVisitorConsent?.();
        if (explicit?.analytics === 'no') return false;
        return eventName === 'cta_view' || (!marketingDenied && marketingAllowed
          && privacy.marketingAllowed?.() === true && explicit?.analytics === 'yes' && explicit?.marketing === 'yes');
      } catch (_) { return false; }
    };
    const visible = (element) => {
      if (!element.isConnected || document.visibilityState !== 'visible') return false;
      for (let node = element; node instanceof HTMLElement; node = node.parentElement) {
        if (node.hidden || node.hasAttribute('inert') || node.getAttribute('aria-hidden') === 'true') return false;
        const style = window.getComputedStyle(node);
        if (style.display === 'none' || ['hidden', 'collapse'].includes(style.visibility)
          || (style.opacity !== '' && Number(style.opacity) <= 0.05)) return false;
      }
      return true;
    };
    const clearCta = (record) => { window.clearTimeout(record.timer); record.timer = null; };
    const qualified = (record) => {
      if (!allowed() || !record.inView || !visible(record.element) || record.element.disabled
        || record.element.getAttribute('aria-disabled') === 'true' || !record.element.matches(ctaSelector)) return false;
      const rect = record.element.getBoundingClientRect();
      const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(0, rect.left));
      const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(0, rect.top));
      return rect.width > 0 && rect.height > 0 && width * height / (rect.width * rect.height) >= 0.5;
    };
    const qualify = (record) => {
      if (seenCtas.has(record.element) || !qualified(record)) { clearCta(record); return; }
      if (record.timer !== null) return;
      record.timer = window.setTimeout(() => {
        record.timer = null;
        syncConsent();
        if (ctas.get(record.element) !== record || !qualified(record) || seenCtas.has(record.element)) return;
        const section = sectionDetails(record.element);
        const placement = record.element.hasAttribute('data-mm-mobile-course-cta-button') ? 'mobile_sticky' : 'product_buy_button';
        if (track('cta_view', { ...section, metadata_json: {
          cta_type: 'purchase', placement, cta_position: placement, duration_ms: 1000,
          element_type: record.element.tagName.toLowerCase(), label: 'Jetzt kaufen – weiter zur Kasse',
        } })) seenCtas.add(record.element);
      }, 1000);
    };
    const metadata = (record, percent) => ({
      ...sectionDetails(record.element), metadata_json: {
        video_provider: record.provider, video_id: record.id,
        video_percent: percent, video_duration_seconds: Math.round(record.duration * 10) / 10,
        video_current_time: Math.round(record.current * 10) / 10,
        video_watched_seconds: Math.round(record.watched * 10) / 10,
        placement: 'course_video',
      },
    });
    const emit = (record, eventName, percent) => {
      const key = `${eventName}:${percent}`;
      if (record.history.has(key)) return;
      if (track(eventName, metadata(record, percent), true)) record.history.add(key);
    };
    const addPlayedRange = (record, start, end) => {
      const ranges = [...record.ranges, [Math.max(0, start), Math.min(record.duration, end)]].sort((a, b) => a[0] - b[0]);
      record.ranges = [];
      for (const range of ranges) {
        const previous = record.ranges[record.ranges.length - 1];
        if (previous && range[0] <= previous[1]) previous[1] = Math.max(previous[1], range[1]);
        else record.ranges.push(range);
      }
      record.watched = record.ranges.reduce((total, [from, to]) => total + Math.max(0, to - from), 0);
    };
    const sample = (record, ending = false) => {
      // Do not read media state while denied, hidden or detached.
      if (!allowed('video_start') || !visible(record.element) || videos.get(record.element) !== record) {
        record.previous = null; return;
      }
      let state;
      try { state = record.read(); } catch (_) { record.previous = null; return; }
      if (!state || !Number.isFinite(state.duration) || state.duration <= 0
        || !Number.isFinite(state.current) || state.current < 0) return;
      record.duration = state.duration; record.current = Math.min(state.current, state.duration);
      const now = Date.now();
      if (state.playing || ending) {
        const previous = record.previous;
        const wall = previous ? (now - previous.at) / 1000 : 0;
        const delta = previous ? record.current - previous.current : 0;
        const expectedAdvance = wall * Math.max(0.25, Math.min(4, state.rate || 1));
        if (previous && wall > 0 && wall <= 2.5 && delta > 0
          && delta <= expectedAdvance + 0.35 && !state.seeking) {
          addPlayedRange(record, previous.current, record.current);
          emit(record, 'video_start', 0);
          for (const percent of [25, 50, 75]) {
            if (record.watched / record.duration * 100 >= percent) emit(record, 'video_progress', percent);
          }
          // YouTube may buffer/restart its existing loop without ENDED. Define
          // completion as near-complete actual viewing: >=95% unique coverage
          // plus continuously reaching the final <=2 API seconds (1s sample +
          // <=1s duration rounding). Do not preserve continuity over buffering.
          if (record.provider === 'youtube' && record.watched / record.duration >= 0.95
            && record.duration - record.current <= Math.min(2, record.duration * 0.05)) {
            emit(record, 'video_complete', 100);
          }
        }
        // YouTube loop=1 may restart without an ENDED callback. Accept only a
        // continuous, near-end wrap matching elapsed playback time; seek jumps,
        // buffering/paused states, hidden time and consent breaks reset previous.
        const wrappedDistance = previous ? record.duration - previous.current + record.current : Infinity;
        // YouTube can report a rounded integer duration while playback wraps at
        // a fractional duration (e.g. 147 reported / 146.4 actual). Native media
        // keeps the stricter tolerance; neither tolerance replaces 95% coverage.
        const wrapTolerance = record.provider === 'youtube' ? 1 : 0.35;
        const endTolerance = record.provider === 'youtube' ? 1 : 0.15;
        const naturalWrap = previous && state.playing && !state.seeking && !ending
          && wall > 0 && wall <= 2.5 && delta < 0
          && record.duration - previous.current <= expectedAdvance + endTolerance
          && Math.abs(wrappedDistance - expectedAdvance) <= wrapTolerance;
        if (naturalWrap && record.watched / record.duration >= 0.95) {
          addPlayedRange(record, previous.current, record.duration);
          addPlayedRange(record, 0, record.current);
          emit(record, 'video_complete', 100);
        }
        // ENDED alone can follow a seek. Require at least 95% actual coverage.
        if (ending && record.watched / record.duration >= 0.95) emit(record, 'video_complete', 100);
      }
      record.previous = state.playing && !state.seeking ? { at: now, current: record.current } : null;
    };
    const createVideo = (element, provider, id, read) => {
      if (!videoHistory.has(element)) videoHistory.set(element, new Set());
      const record = { element, provider, id, read, history: videoHistory.get(element), ranges: [],
        watched: 0, current: 0, duration: 0, previous: null, dispose: () => {} };
      videos.set(element, record);
      return record;
    };
    const youtubeId = (element) => {
      try {
        const url = new URL(element.getAttribute('src'), location.origin);
        if (!['https://www.youtube.com', 'https://www.youtube-nocookie.com'].includes(url.origin)
          || url.searchParams.get('enablejsapi') !== '1') return '';
        return /^\/embed\/([A-Za-z0-9_-]{11})$/.exec(url.pathname)?.[1] || '';
      } catch (_) { return ''; }
    };
    const attachYoutube = (element, id) => {
      if (!window.YT?.Player || players.has(element)) return;
      const holder = { player: null, ready: false, id };
      players.set(element, holder);
      try {
        holder.player = new window.YT.Player(element, { events: {
          onReady: () => { holder.ready = true; reconcile(); },
          onStateChange: (event) => {
            const record = videos.get(element);
            if (record) sample(record, event.data === 0);
          },
        } });
      } catch (_) { players.delete(element); }
    };
    const requestYoutubeApi = () => {
      if (apiRequested || window.YT?.Player || !allowed('video_start')) return;
      apiRequested = true;
      if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) return;
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function (...args) {
        try { if (typeof previous === 'function') previous.apply(this, args); }
        finally { reconcile(); }
      };
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api'; script.async = true;
      document.head.appendChild(script);
    };
    const stopVideos = () => {
      videos.forEach((record) => record.dispose());
      videos.clear();
      // Never destroy an existing YouTube player: destroy() removes its iframe.
      // Dormant callbacks perform no media reads, collection or playback actions.
    };
    const stop = () => {
      ctas.forEach((record) => { clearCta(record); record.observer.disconnect(); }); ctas.clear();
      mutationObserver?.disconnect(); mutationObserver = null;
      stopVideos();
    };
    const reconcile = () => {
      if (!allowed()) { stop(); return; }
      const main = document.getElementById('MainContent') || document.querySelector('main');
      if (!main) return;
      for (const [element, record] of ctas) {
        if (!element.isConnected || !element.matches(ctaSelector)) {
          clearCta(record); record.observer.disconnect(); ctas.delete(element);
        } else qualify(record);
      }
      if (typeof IntersectionObserver === 'function') main.querySelectorAll(ctaSelector).forEach((element) => {
        if (ctas.has(element) || seenCtas.has(element)) return;
        const record = { element, inView: false, timer: null };
        record.observer = new IntersectionObserver((entries) => {
          syncConsent();
          if (ctas.get(element) !== record) return;
          entries.forEach((entry) => { if (entry.target === element) record.inView = entry.isIntersecting && entry.intersectionRatio >= 0.5; });
          qualify(record);
        }, { threshold: [0, 0.5, 1] });
        ctas.set(element, record); record.observer.observe(element);
      });
      if (!mutationObserver && typeof MutationObserver === 'function') {
        mutationObserver = new MutationObserver((mutations) => {
          // Unrelated app polling (e.g. Klarna fallback.hidden every second)
          // must not perpetually restart every button's one-second timer.
          ctas.forEach((record) => {
            if (mutations.some(({ target }) => target === record.element
              || target.contains?.(record.element) || record.element.contains(target))) clearCta(record);
          });
          reconcile();
        });
        mutationObserver.observe(main, { childList: true, subtree: true, attributes: true,
          attributeFilter: ['hidden', 'inert', 'aria-hidden', 'style', 'class', 'disabled', 'aria-disabled', 'src'] });
      }
      if (!allowed('video_start')) { stopVideos(); return; }
      for (const [element, record] of videos) {
        if (!element.isConnected || (record.provider === 'youtube' && youtubeId(element) !== record.id)) {
          record.dispose(); videos.delete(element);
        }
      }
      main.querySelectorAll('video').forEach((element) => {
        if (videos.has(element)) return;
        // Never send a media URL or title. DOM-local identifiers are sufficient.
        if (!nativeIds.has(element)) nativeIds.set(element,
          `html5-${sectionDetails(element).section_id || 'course'}-${++serial}`.replace(/[^a-zA-Z0-9_-]/g, '-').slice(0, 120));
        const id = nativeIds.get(element);
        const record = createVideo(element, 'html5', id, () => ({ duration: element.duration,
          current: element.currentTime, playing: !element.paused && !element.ended,
          seeking: element.seeking, rate: element.playbackRate }));
        const onState = () => sample(record);
        const onEnded = () => sample(record, true);
        const reset = () => { record.previous = null; };
        for (const name of ['playing', 'timeupdate', 'pause', 'ratechange']) element.addEventListener(name, onState);
        element.addEventListener('ended', onEnded); element.addEventListener('seeking', reset);
        record.dispose = () => {
          for (const name of ['playing', 'timeupdate', 'pause', 'ratechange']) element.removeEventListener(name, onState);
          element.removeEventListener('ended', onEnded); element.removeEventListener('seeking', reset);
        };
      });
      main.querySelectorAll('iframe').forEach((element) => {
        const id = youtubeId(element);
        if (!id) return;
        requestYoutubeApi(); attachYoutube(element, id);
        const holder = players.get(element);
        if (!holder?.ready || !holder.player || videos.has(element) || holder.id !== id) return;
        createVideo(element, 'youtube', id, () => ({ duration: holder.player.getDuration(),
          current: holder.player.getCurrentTime(), playing: holder.player.getPlayerState() === 1,
          rate: holder.player.getPlaybackRate?.() || 1 }));
      });
      videos.forEach((record) => sample(record));
    };
    document.addEventListener('visibilitychange', () => {
      ctas.forEach(clearCta); videos.forEach((record) => { record.previous = null; }); reconcile();
    });
    return { allowed, isEvent: (name) => events.has(name), reconcile, stop,
      consent(detail) {
        if (typeof detail?.analyticsAllowed === 'boolean') analyticsDenied = !detail.analyticsAllowed;
        if (typeof detail?.marketingAllowed === 'boolean') marketingDenied = !detail.marketingAllowed;
        if (analyticsDenied || marketingDenied) stop();
      },
      page(value) { active = value; if (!value) stop(); else reconcile(); },
    };
  })();

  // Controllers dispatch these events only after their stated stage has been
  // confirmed. Read an explicit allowlist, never raw form/cart/customer payloads.
  const safeIdentifier = (value) => typeof value === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9_.:-]{0,159}$/.test(value) ? value : '';
  const checkoutDetails = (detail) => {
    if (!detail || typeof detail !== 'object') return null;
    const operationId = safeIdentifier(detail.operationId);
    const variantId = String(detail.variantId || '');
    if (!operationId || !/^\d{1,24}$/.test(variantId)) return null;
    const formId = safeIdentifier(detail.formId);
    const form = formId ? document.getElementById(formId) : null;
    return {
      operationId,
      eventDetails: {
        ...sectionDetails(form),
        metadata_json: {
          variant_id: variantId,
          form_id: formId,
          operation_id: operationId,
          purchase_source: detail.source,
        },
      },
    };
  };

  document.addEventListener('mm:cart-add-confirmed', (event) => {
    syncConsent();
    if (!analyticsAllowed) return;
    const detail = event.detail;
    if (!detail || !['product-form', 'course-checkout'].includes(detail.source)) return;
    const normalized = checkoutDetails(detail);
    const quantity = Number(detail.quantity);
    if (!normalized || !Number.isSafeInteger(quantity) || quantity < 1) return;
    if (confirmedCartOperations.has(normalized.operationId)) return;
    confirmedCartOperations.add(normalized.operationId);
    normalized.eventDetails.metadata_json.quantity = quantity;
    track('add_to_cart', normalized.eventDetails);
  });

  document.addEventListener('mm:checkout-flow', (event) => {
    syncConsent();
    if (!analyticsAllowed) return;
    const detail = event.detail;
    if (!detail || detail.source !== 'course-checkout') return;
    if (!['consent_error', 'checkout_redirect', 'purchase_error'].includes(detail.stage)) return;
    const normalized = checkoutDetails(detail);
    if (!normalized) return;
    const deduplicationKey = `${normalized.operationId}:${detail.stage}`;
    if (checkoutFlowOperations.has(deduplicationKey)) return;
    checkoutFlowOperations.add(deduplicationKey);
    track(detail.stage, normalized.eventDetails);
  });

  // The adapter alone qualifies viewport duration and receives the official SDK
  // click. This narrow bridge never reads iframe content or callback payloads.
  document.addEventListener('mm:paypal-message', (event) => {
    syncConsent();
    if (!analyticsAllowed || !marketingAllowed || config.page_type !== 'product'
      || !Object.values(courseIdsByHandle).includes(String(config.product?.id))) return;
    const detail = event.detail;
    const host = event.target;
    if (!event.cancelable || event.defaultPrevented || !detail || typeof detail !== 'object'
      || Array.isArray(detail) || Object.keys(detail).length !== 3
      || !['view', 'info'].includes(detail.kind) || detail.placement !== 'product'
      || detail.version !== 'prominent-v1') return;
    if (!(host instanceof HTMLElement) || !host.isConnected
      || !host.matches('[data-mm-paypal][data-mm-placement="product"]')
      || host.dataset.mmPaypalStatus !== 'ready' || host.closest('[hidden], [inert]')
      || host.dataset.mmCurrency !== 'EUR' || host.dataset.mmCountry !== 'DE') return;
    const target = host.querySelector('[data-mm-paypal-target]');
    if (!target || !target.isConnected || target.closest('[hidden], [inert]')) return;
    const rawCents = host.dataset.mmAmountCents || '';
    const quantityInput = host.closest('product-info')?.querySelector('input[name="quantity"]');
    const rawQuantity = quantityInput ? quantityInput.value.trim() : '1';
    if (!/^\d+$/.test(rawCents) || !/^\d+$/.test(rawQuantity)) return;
    const quantity = Number(rawQuantity);
    const cents = Number(rawCents) * quantity;
    if (!Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(cents)
      || cents < 100 || cents > 1000000) return;

    const key = `${config.product.id}:product`;
    if (detail.kind === 'view' && paypalViews.has(key)) {
      event.preventDefault(); // Legitimate requalification: already accepted once.
      return;
    }
    const now = Date.now();
    if (detail.kind === 'info' && now - lastPaypalInfoAt < 500) return;
    const view = detail.kind === 'view';
    const accepted = track(view ? 'section_view' : 'cta_click', {
      section_id: 'mm-paypal-product',
      section_name: 'PayPal-Zahlungsoptionen',
      metadata_json: {
        placement: 'product',
        element_type: 'paypal_message',
        label: view ? 'PayPal-Hinweis sichtbar' : 'PayPal-Information angefordert',
        operation_id: `paypal-prominent-v1:product:${view ? 'view' : `info:${paypalInfoCounter + 1}`}`,
        ...(view ? { duration_ms: 1000 } : {
          cta_type: 'paypal_info', cta_position: 'mm-paypal-product', destination_path: '',
        }),
      },
    }, true);
    if (!accepted) return;
    if (view) paypalViews.add(key);
    else { lastPaypalInfoAt = now; paypalInfoCounter += 1; }
    // ACK is acceptance by the consent-aware theme queue, not a receipt from the
    // pixel/collector. No pre-consent events are retained for a later grant.
    event.preventDefault();
  });

  // Observe only the official app's populated open shadow message. This code
  // does not load Klarna, change app state, or treat our wrapper as an impression.
  const klarnaScope = config.page_type === 'product'
    && Object.values(courseIdsByHandle).includes(String(config.product?.id));
  const klarnaWrapperSelector = '[data-mm-klarna-presentation="prominent-v1"]';
  const klarnaPlacementSelector = 'klarna-placement[data-key="credit-promotion-badge"]';
  const klarnaConsentAllowed = () => {
    if (!klarnaScope) return false;
    try {
      const api = window.Shopify?.customerPrivacy;
      const latestAnalytics = api?.analyticsProcessingAllowed?.();
      const latestMarketing = api?.marketingAllowed?.();
      const explicit = api?.currentVisitorConsent?.();
      if (latestAnalytics === false || latestMarketing === false || explicit?.marketing === 'no' || explicit?.analytics === 'no') klarnaDeniedLatch = false;
      return analyticsAllowed && marketingAllowed && latestAnalytics === true && latestMarketing === true && !klarnaDeniedLatch
        && explicit?.marketing === 'yes' && explicit?.analytics === 'yes';
    } catch (_) { return false; }
  };
  const discardKlarnaPending = () => {
    // Explicit-consent changes must not discard unrelated analytics. Already
    // handed-off pixel requests cannot be recalled, but no theme retry survives.
    if (inFlight?.entry.payload.section_id === 'mm-klarna-product') {
      window.clearTimeout(inFlight.timer);
      inFlight = null;
    }
    for (let index = pendingEvents.length - 1; index >= 0; index -= 1) {
      if (pendingEvents[index].payload.section_id === 'mm-klarna-product') pendingEvents.splice(index, 1);
    }
  };
  const clearKlarnaTimer = (record) => {
    window.clearTimeout(record.timer);
    record.timer = null;
  };
  const disposeKlarna = (record) => {
    clearKlarnaTimer(record);
    record.intersection?.disconnect();
    record.mutations?.disconnect();
    klarnaRecords.delete(record.placement);
  };
  const stopKlarna = () => {
    for (const record of klarnaRecords.values()) disposeKlarna(record);
  };
  const visibleKlarnaElement = (element) => {
    for (let current = element; current instanceof HTMLElement;
      current = current.parentElement || current.getRootNode()?.host) {
      if (current.hidden || current.hasAttribute('inert') || current.getAttribute('aria-hidden') === 'true') return false;
      const style = window.getComputedStyle(current);
      if (style.display === 'none' || ['hidden', 'collapse'].includes(style.visibility) || style.opacity === '0') return false;
    }
    return true;
  };
  const validKlarna = (record) => klarnaConsentAllowed() && klarnaPageActive
    && record.epoch === consentEpoch && klarnaRecords.get(record.placement) === record
    && record.placement.isConnected && record.wrapper.isConnected
    && record.wrapper.matches(klarnaWrapperSelector)
    && record.placement.closest(klarnaWrapperSelector) === record.wrapper
    && record.placement.matches(klarnaPlacementSelector)
    && record.placement.shadowRoot === record.root
    && record.message?.isConnected && record.root.contains(record.message)
    && record.message.matches('[part~="osm-message"]')
    && Boolean(record.message.textContent.trim()) && visibleKlarnaElement(record.message);
  const qualifiedKlarna = (record) => {
    if (!record.inView || document.visibilityState !== 'visible' || !validKlarna(record)) return false;
    const rect = record.message.getBoundingClientRect();
    const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(0, rect.left));
    const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(0, rect.top));
    return rect.width > 0 && rect.height > 0 && width * height / (rect.width * rect.height) >= 0.5;
  };
  const trackKlarna = (kind) => track(kind === 'view' ? 'section_view' : 'cta_click', {
    section_id: 'mm-klarna-product', section_name: 'Klarna-Zahlungsoptionen',
    metadata_json: {
      placement: 'product', element_type: 'klarna_message',
      label: kind === 'view' ? 'Klarna-Hinweis sichtbar' : 'Klarna-Information angefordert',
      operation_id: `klarna-prominent-v1:product:${kind === 'view' ? 'view' : `info:${klarnaInfoCounter + 1}`}`,
      ...(kind === 'view' ? { duration_ms: 1000 } : {
        cta_type: 'klarna_info', cta_position: 'mm-klarna-product', destination_path: '',
      }),
    },
  }, true);
  const qualifyKlarna = (record) => {
    if (klarnaViewTracked || !qualifiedKlarna(record)) { clearKlarnaTimer(record); return; }
    if (record.timer !== null) return;
    record.timer = window.setTimeout(() => {
      record.timer = null;
      syncConsent();
      if (!klarnaViewTracked && qualifiedKlarna(record) && trackKlarna('view')) {
        klarnaViewTracked = true;
        for (const other of klarnaRecords.values()) clearKlarnaTimer(other);
      }
    }, 1000);
  };
  const refreshKlarna = (record) => {
    const message = record.root.querySelector('[part~="osm-message"]');
    if (message !== record.message) {
      clearKlarnaTimer(record);
      record.intersection?.disconnect();
      record.intersection = null;
      record.message = message;
      record.inView = false;
      if (message && typeof IntersectionObserver === 'function') {
        record.intersection = new IntersectionObserver((entries) => {
          syncConsent();
          for (const entry of entries) {
            if (entry.target !== record.message) continue;
            record.inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
            qualifyKlarna(record);
          }
        }, { threshold: [0, 0.5, 1] });
        record.intersection.observe(message);
      }
    }
    qualifyKlarna(record);
  };
  const reconcileKlarna = () => {
    if (!klarnaScope || !klarnaPageActive) { stopKlarna(); return; }
    if (!klarnaConsentAllowed()) { stopKlarna(); discardKlarnaPending(); return; }
    for (const record of klarnaRecords.values()) {
      if (!record.placement.isConnected || record.placement.closest(klarnaWrapperSelector) !== record.wrapper
        || record.placement.shadowRoot !== record.root || !record.placement.matches(klarnaPlacementSelector)) disposeKlarna(record);
    }
    document.querySelectorAll(`${klarnaWrapperSelector} ${klarnaPlacementSelector}`).forEach((placement) => {
      if (!placement.shadowRoot) return;
      let record = klarnaRecords.get(placement);
      if (!record) {
        record = { placement, wrapper: placement.closest(klarnaWrapperSelector), root: placement.shadowRoot,
          epoch: consentEpoch, timer: null, message: null, inView: false };
        klarnaRecords.set(placement, record);
        if (typeof MutationObserver === 'function') {
          record.mutations = new MutationObserver(() => {
            syncConsent();
            clearKlarnaTimer(record); // Content or visibility changes restart a full second.
            if (klarnaRecords.get(placement) === record) refreshKlarna(record);
          });
          record.mutations.observe(record.root, { subtree: true, childList: true, characterData: true,
            attributes: true, attributeFilter: ['part', 'hidden', 'inert', 'aria-hidden', 'class', 'style'] });
          for (let ancestor = placement; ancestor instanceof HTMLElement; ancestor = ancestor.parentElement) {
            record.mutations.observe(ancestor, { attributes: true,
              attributeFilter: ['hidden', 'inert', 'aria-hidden', 'class', 'style', 'data-key', 'data-mm-klarna-presentation'] });
          }
        }
      }
      refreshKlarna(record);
    });
  };
  document.addEventListener('visibilitychange', () => {
    syncConsent();
    for (const record of klarnaRecords.values()) {
      clearKlarnaTimer(record);
      qualifyKlarna(record);
    }
  });
  document.addEventListener('click', (event) => {
    syncConsent();
    if (!klarnaConsentAllowed() || document.visibilityState !== 'visible') return;
    const eventPath = event.composedPath?.() || [];
    const placement = eventPath.find((node) => node instanceof HTMLElement && node.matches(klarnaPlacementSelector));
    if (!placement?.closest(klarnaWrapperSelector)) return;
    reconcileKlarna();
    const record = klarnaRecords.get(placement);
    if (!record || !validKlarna(record)) return;
    const cta = eventPath.find((node) => node instanceof HTMLElement && node.matches('button[part~="osm-cta"], a[part~="osm-cta"]'));
    if (!cta || !record.root.contains(cta) || !visibleKlarnaElement(cta) || cta.disabled) return;
    const now = Date.now();
    if (now - lastKlarnaInfoAt < 500 || !trackKlarna('info')) return;
    lastKlarnaInfoAt = now;
    klarnaInfoCounter += 1;
  }, true);

  const observePerformance = () => {
    if (typeof PerformanceObserver !== 'function') return;
    const epoch = consentEpoch;
    const startedAt = window.performance?.now?.() || 0;
    const observe = (type, consume, options = {}) => {
      try {
        const observer = new PerformanceObserver((list) => {
          syncConsent();
          if (!analyticsAllowed || epoch !== consentEpoch) return;
          list.getEntries().filter((entry) => entry.startTime >= startedAt).forEach(consume);
        });
        observer.observe({ type, buffered: false, ...options });
        performanceObservers.push(observer);
      } catch (error) {}
    };
    observe('largest-contentful-paint', (entry) => { vitals.lcp = Math.round(entry.startTime); });
    observe('layout-shift', (entry) => { if (!entry.hadRecentInput) vitals.cls += entry.value; });
    observe('event', (entry) => {
      if (entry.interactionId) vitals.inp = Math.max(vitals.inp, Math.round(entry.duration));
    }, { durationThreshold: 40 });
  };

  const publishVitals = () => {
    syncConsent();
    if (!analyticsAllowed || vitalsPublished) return;
    vitalsPublished = true;
    Object.entries(vitals).forEach(([metric, value]) => {
      if (value > 0) track('web_vital', { metadata_json: { metric, value } });
    });
  };

  const trackCta = (target) => {
    syncConsent();
    if (!analyticsAllowed) return;
    const now = Date.now();
    if (now - lastCtaAt < 400) return;
    lastCtaAt = now;
    const section = sectionDetails(target);
    const href = target?.getAttribute?.('href') || target?.getAttribute?.('action') || target?.closest?.('form')?.action || '';
    const destinationHandle = target?.dataset?.mmHomeCourse || productHandleFromUrl(href);
    const isCoursePurchase = Boolean(target?.matches?.('[data-mm-mobile-course-cta-button]')
      || target?.closest?.('form[data-mm-course-checkout-form="true"]'));
    const placement = isCoursePurchase
      ? (target?.matches?.('[data-mm-mobile-course-cta-button]') ? 'mobile_sticky' : 'product_buy_button')
      : target?.dataset?.mmPlacement || section.section_id || 'unbekannt';
    const normalizedHref = compactText(href.split(/[?#]/)[0], 1024);
    const isCheckout = normalizedHref.includes('/checkout');
    const isProduct = Boolean(destinationHandle);
    track('cta_click', {
      ...section,
      metadata_json: {
        label: compactText(target?.textContent || target?.value, 160),
        destination_product_handle: compactText(destinationHandle, 255),
        destination_product_id: courseIdsByHandle[destinationHandle] || '',
        destination_path: normalizedHref,
        placement: compactText(placement, 120),
        cta_position: compactText(placement, 120),
        cta_type: isCoursePurchase ? 'purchase' : (isCheckout ? 'checkout' : (isProduct ? 'course_navigation' : 'action')),
        element_type: compactText(target?.tagName?.toLowerCase(), 40),
      },
    });
  };

  // Versioned course-only viewport measurement. This measures exposure, never
  // claims reading, and keeps sections separate from actual scroll movement.
  const viewportMeasurement = (() => {
    const scope = config.page_type === 'product'
      && Object.values(courseIdsByHandle).includes(String(config.product?.id));
    const heroIds = new Set(['hero_benefits', 'hero_proof', 'preview_teaser']);
    const observed = new Map(), seen = new Set(), milestones = new Set();
    const now = () => window.performance.now();
    let enabled = false, pageActive = true, denied = false, timer = null;
    let mutations, resizing, shifts, mutationTimer = null;
    let position = null, intent = null;
    const sameProduct = () => window.location.pathname.replace(/\/$/, '') === `/products/${config.product?.handle}`;
    const permitted = () => scope && enabled && pageActive && analyticsAllowed && !denied && sameProduct();
    const visibleDocument = () => document.visibilityState === 'visible';
    const cssVisible = (element, styles) => {
      if (!element.isConnected) return false;
      for (let node = element; node instanceof HTMLElement; node = node.parentElement) {
        if (!styles.has(node)) styles.set(node, window.getComputedStyle(node));
        const style = styles.get(node);
        if (node.hidden || node.hasAttribute('inert') || node.getAttribute('aria-hidden') === 'true'
          || style.display === 'none' || ['hidden', 'collapse'].includes(style.visibility)
          || (style.opacity !== '' && Number(style.opacity) <= 0.05)) return false;
      }
      return true;
    };
    const qualified = (element, styles) => {
      if (!permitted() || !visibleDocument() || !element.isConnected) return false;
      const rect = element.getBoundingClientRect();
      const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(0, rect.top));
      const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(0, rect.left));
      return rect.width > 0 && rect.height > 0 && width > 0
        && height >= Math.min(rect.height * 0.25, window.innerHeight * 0.25) && cssVisible(element, styles);
    };
    const metadata = (record, extra = {}) => ({ measurement_version: measurementVersion,
      ...(record.hero ? { content_scope: 'hero' } : {}), ...extra });
    const finishRecord = (record, emit = true) => {
      if (record.since === null) return;
      const duration = Math.max(0, now() - record.since);
      record.since = null;
      if (emit && duration >= 2000 && seen.has(record.key)) track('section_engaged', {
        ...record.details, metadata_json: metadata(record, { duration_ms: Math.round(duration) }),
      });
    };
    const finish = (emit = true) => observed.forEach((record) => finishRecord(record, emit));
    const records = () => {
      const result = new Map();
      const main = document.getElementById('MainContent') || document.querySelector('main');
      trackedSections().forEach((element) => {
        const details = sectionDetails(element);
        if (details.section_id && !result.has(`section:${details.section_id}`)) {
          result.set(`section:${details.section_id}`, { element, details, hero: false });
        }
      });
      main?.querySelectorAll('[data-mm-content-id]').forEach((element) => {
        const id = element.getAttribute('data-mm-content-id');
        if (!heroIds.has(id) || result.has(`hero:${id}`)) return;
        const parent = sectionDetails(element);
        result.set(`hero:${id}`, { element, hero: true, details: {
          section_id: id, section_name: id, section_index: parent.section_index || 0,
        } });
      });
      return result;
    };
    const sample = () => {
      syncConsent();
      if (!permitted()) { finish(false); return; }
      if (!visibleDocument()) return;
      const styles = new Map();
      const current = records();
      for (const [key, record] of observed) {
        if (current.get(key)?.element !== record.element) { finishRecord(record); observed.delete(key); }
      }
      for (const [key, item] of current) {
        if (!observed.has(key)) observed.set(key, { ...item, key, since: null });
        const record = observed.get(key);
        record.details = item.details;
        if (!qualified(record.element, styles)) { finishRecord(record); continue; }
        if (record.since === null) record.since = now();
        if (!seen.has(key) && now() - record.since >= 1000) {
          if (track('section_view', { ...record.details, metadata_json: metadata(record) })) seen.add(key);
        }
      }
    };
    const geometry = () => {
      const root = document.scrollingElement || document.documentElement;
      const height = Math.max(root?.scrollHeight || 0, document.body?.scrollHeight || 0);
      const range = Math.max(0, height - window.innerHeight);
      const y = Math.max(0, Math.min(range, window.scrollY || root?.scrollTop || 0));
      return { y, range, height, viewport: window.innerHeight, width: window.innerWidth,
        percent: range > 0 ? y / range * 100 : 0 };
    };
    const resetScroll = () => {
      position = enabled && analyticsAllowed && !denied && pageActive ? geometry() : null;
      intent = null;
    };
    const resized = (a, b) => !a || a.height !== b.height || a.viewport !== b.viewport || a.width !== b.width;
    const beginIntent = (origin, event, fragmentUrl = '') => {
      if (event.isTrusted !== true || !permitted() || !visibleDocument()) return;
      const current = geometry();
      if (resized(position, current)) resetScroll();
      if (origin === 'anchor' || !intent || intent.origin !== origin || intent.until < now()) {
        intent = { origin, from: current.y, percent: current.percent, until: now() + 1500, fragmentUrl };
      } else intent.until = now() + 1500;
      position = current;
    };
    const onScroll = () => {
      syncConsent();
      if (!permitted() || !visibleDocument()) { resetScroll(); return; }
      const current = geometry();
      if (resized(position, current) || !intent || intent.until < now()) { resetScroll(); sample(); return; }
      const previous = position;
      const gesture = intent;
      position = current;
      if (current.y === previous.y) return;
      gesture.fragmentUrl = '';
      gesture.until = now() + 500;
      const progressed = Math.abs(current.y - gesture.from) >= 32;
      const emit = (milestone) => {
        if (milestones.has(milestone)) return;
        if (track('scroll_progress', { metadata_json: { measurement_version: measurementVersion,
          scroll_milestone: milestone, scroll_origin: gesture.origin } })) milestones.add(milestone);
      };
      if (progressed) {
        emit(0);
        // A late grant/restore/deep link establishes a new baseline. Crossing
        // lower milestones before permission never gets replayed afterwards.
        if (current.y > gesture.from) for (const milestone of [25, 50, 75, 90]) {
          if (gesture.percent < milestone && current.percent >= milestone) emit(milestone);
        }
      }
      sample();
    };
    const onGeometry = () => { resetScroll(); sample(); };
    const onHistory = () => {
      // Native fragment navigation fires popstate before scrolling. Preserve
      // only the fresh, exact destination armed by a trusted anchor click, and
      // consume it once. Back/forward or unrelated navigation still resets.
      syncConsent();
      if (permitted() && visibleDocument() && intent?.origin === 'anchor'
        && intent.until >= now() && intent.fragmentUrl === window.location.href) {
        intent.fragmentUrl = '';
        sample();
        return;
      }
      onGeometry();
    };
    const schedule = () => {
      if (timer !== null || !enabled || !visibleDocument()) return;
      timer = window.setTimeout(() => { timer = null; sample(); schedule(); }, 250);
    };
    const start = () => {
      if (!scope || enabled || !pageActive || denied || !analyticsAllowed) return;
      enabled = true; resetScroll(); sample(); schedule();
      const main = document.getElementById('MainContent') || document.querySelector('main');
      if (main && typeof MutationObserver === 'function') {
        mutations = new MutationObserver(() => {
          // Batch widget/variant mutation bursts. Hidden tabs do no viewport
          // polling; CSS is inspected only for geometrically near sections.
          if (!enabled || !visibleDocument() || mutationTimer !== null) return;
          mutationTimer = window.setTimeout(() => {
            mutationTimer = null;
            if (resized(position, geometry())) resetScroll();
            sample();
          }, 0);
        });
        mutations.observe(main, { childList: true, subtree: true, attributes: true,
          attributeFilter: ['hidden', 'inert', 'aria-hidden', 'style', 'class', 'data-mm-content-id'] });
      }
      if (typeof ResizeObserver === 'function') {
        resizing = new ResizeObserver(() => { if (resized(position, geometry())) onGeometry(); });
        resizing.observe(document.documentElement);
      }
      if (typeof PerformanceObserver === 'function') {
        try { shifts = new PerformanceObserver(() => onGeometry()); shifts.observe({ type: 'layout-shift', buffered: false }); }
        catch (_) { shifts = null; }
      }
    };
    const stop = () => {
      enabled = false; finish(false); observed.clear(); resetScroll();
      window.clearTimeout(timer); timer = null;
      window.clearTimeout(mutationTimer); mutationTimer = null;
      mutations?.disconnect(); mutations = null;
      resizing?.disconnect(); resizing = null;
      shifts?.disconnect(); shifts = null;
    };
    if (scope) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onGeometry, { passive: true });
      window.visualViewport?.addEventListener('resize', onGeometry, { passive: true });
      document.addEventListener('wheel', (event) => beginIntent('user', event), { passive: true });
      document.addEventListener('touchmove', (event) => beginIntent('user', event), { passive: true });
      document.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)
          || event.altKey || event.ctrlKey || event.metaKey || event.target?.closest?.('input, textarea, select, [contenteditable="true"]')) return;
        beginIntent('user', event);
      });
      document.addEventListener('pointerdown', (event) => {
        if (event.clientX >= document.documentElement.clientWidth && event.clientX >= window.innerWidth - 24) beginIntent('user', event);
      }, { passive: true });
      document.addEventListener('click', (event) => {
        const href = event.target?.closest?.('a[href]')?.getAttribute('href');
        if (!href) return;
        try {
          const url = new URL(href, window.location.href);
          if (url.hash && url.origin === window.location.origin && url.pathname === window.location.pathname) beginIntent('anchor', event, url.href);
        } catch (_) {}
      }, true);
      document.addEventListener('visibilitychange', () => {
        if (!visibleDocument()) {
          finish(permitted()); window.clearTimeout(timer); timer = null;
          window.clearTimeout(mutationTimer); mutationTimer = null;
        }
        resetScroll();
        if (visibleDocument()) { sample(); schedule(); }
      });
      window.addEventListener('popstate', onHistory);
    }
    return { scope, start, stop, finish,
      consent(detail) {
        if (typeof detail?.analyticsAllowed === 'boolean') denied = !detail.analyticsAllowed;
        if (denied) stop();
      },
      page(value) {
        pageActive = value;
        if (!value) stop(); else start();
      },
    };
  })();

  const observeSections = () => {
    if (viewportMeasurement.scope) { viewportMeasurement.start(); return; }
    if (typeof IntersectionObserver !== 'function') return;
    const sections = trackedSections();
    const epoch = consentEpoch;
    sectionObserver = new IntersectionObserver((entries) => {
      syncConsent();
      if (!analyticsAllowed || epoch !== consentEpoch) return;
      entries.forEach((entry) => {
        const details = sectionDetails(entry.target);
        if (!details.section_id) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.15) {
          if (!seenSections.has(details.section_id)) {
            seenSections.add(details.section_id);
            activeSections.set(details.section_id, Date.now());
            track('section_view', details);
          } else if (!activeSections.has(details.section_id)) {
            activeSections.set(details.section_id, Date.now());
          }
          return;
        }
        const startedAt = activeSections.get(details.section_id);
        if (startedAt) {
          const duration = Date.now() - startedAt;
          activeSections.delete(details.section_id);
          if (duration >= 2000) track('section_engaged', { ...details, metadata_json: { duration_ms: duration } });
        }
      });
    }, { threshold: [0, 0.15, 0.5], rootMargin: '-10% 0px -10% 0px' });
    sections.forEach((section) => sectionObserver.observe(section));
  };

  const bindInteractions = () => {
    document.addEventListener('click', (event) => {
      syncConsent();
      if (!analyticsAllowed) return;
      const target = event.target?.closest?.('a, button, input[type="submit"]');
      if (!target) return;
      if (target.closest('[data-mm-paypal], [data-mm-paypal-card], [data-mm-klarna-presentation]')) return;
      const label = compactText(target.textContent || target.value, 160).toLowerCase();
      const href = target.getAttribute('href') || '';
      if (
        target.hasAttribute('data-mm-home-course')
        || target.hasAttribute('data-mm-placement')
        || /jetzt|lernen|kaufen|warenkorb|kurs starten|checkout/.test(label)
        || href.includes('/checkout')
      ) trackCta(target);
    }, true);

    document.addEventListener('submit', (event) => {
      syncConsent();
      if (!analyticsAllowed) return;
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
      trackCta(form.querySelector('[type="submit"]') || form);
      track('add_to_cart_attempt', sectionDetails(form));
    }, true);

    document.addEventListener('toggle', (event) => {
      syncConsent();
      if (!analyticsAllowed) return;
      if (event.target instanceof HTMLDetailsElement && event.target.open) {
        track('faq_open', {
          ...sectionDetails(event.target),
          metadata_json: { question: compactText(event.target.querySelector('summary')?.textContent, 200) },
        });
      }
    }, true);
  };

  const finishActiveSections = () => {
    syncConsent();
    if (!analyticsAllowed) return;
    if (viewportMeasurement.scope) viewportMeasurement.finish();
    activeSections.forEach((startedAt, sectionId) => {
      const duration = Date.now() - startedAt;
      if (duration < 2000) return;
      const section = trackedSections()
        .find((item) => item.id === `shopify-section-${sectionId}` || item.id.endsWith(`__${sectionId}`));
      track('section_engaged', { ...sectionDetails(section), metadata_json: { duration_ms: duration } });
    });
    activeSections.clear();
    publishVitals();
    publishPending();
  };

  const stopCollection = () => {
    stopKlarna();
    courseMeasurement.stop();
    viewportMeasurement.stop();
    collectionActive = false;
    sectionObserver?.disconnect();
    sectionObserver = null;
    performanceObservers.splice(0).forEach((observer) => observer.disconnect());
    window.clearTimeout(vitalsTimer);
    activeSections.clear();
    vitals.cls = 0;
    vitals.inp = 0;
    vitals.lcp = 0;
    lastCtaAt = 0;
  };

  const startCollection = () => {
    if (collectionActive) return;
    collectionActive = true;
    // One canonical page view per actual document. A revoked/discarded page
    // view is not replayed if consent is later granted again on this page.
    if (!pageViewTracked) {
      pageViewTracked = true;
      track('page_view');
    }
    observeSections();
    observePerformance();
    vitalsTimer = window.setTimeout(publishVitals, 15000);
  };

  // Shopify's Allowed methods include merchant settings, region and visitor
  // consent. Never infer permission from publisher availability or cookies.
  const syncConsent = (detail) => {
    if (syncingConsent) return;
    syncingConsent = true;
    try {
      if (detail && typeof detail === 'object') {
        for (const key of ['analyticsAllowed', 'marketingAllowed']) {
          if (typeof detail[key] === 'boolean') consentEventState[key] = detail[key];
        }
      }
      const privacy = window.Shopify?.customerPrivacy;
      const permission = (method, key) => {
        if (typeof detail?.[key] === 'boolean') return detail[key];
        // An explicit rejection received by this document remains authoritative
        // across polling and BFCache. Cached Allowed methods cannot revoke that
        // rejection; only a later explicit consent event can grant it again.
        if (consentEventState[key] === false) return false;
        if (typeof privacy?.[method] === 'function') {
          try { return privacy[method]() === true; } catch (error) { return false; }
        }
        return consentEventState[key];
      };
      const nextAnalytics = permission('analyticsProcessingAllowed', 'analyticsAllowed');
      const nextMarketing = permission('marketingAllowed', 'marketingAllowed');
      const lostAnalytics = analyticsAllowed && nextAnalytics !== true;
      const lostMarketing = marketingAllowed && nextMarketing !== true;
      if (lostAnalytics || lostMarketing) {
        discardPending();
        stopCollection();
      }
      if (nextAnalytics === false) clearQaContext();
      if (lostAnalytics || lostMarketing || nextAnalytics === false || nextMarketing === false) clearAttribution();
      analyticsAllowed = nextAnalytics === true;
      marketingAllowed = nextMarketing === true;
      if (analyticsAllowed) startCollection();
    } finally {
      syncingConsent = false;
    }
  };

  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy || privacyLoadRequested || Date.now() < nextPrivacyLoadAt) return;
    const shopify = window.Shopify;
    if (typeof shopify?.loadFeatures !== 'function') return;
    privacyLoadRequested = true;
    nextPrivacyLoadAt = Date.now() + 30000;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
        privacyLoadRequested = false;
        syncConsent();
        publishPending();
      });
    } catch (error) { privacyLoadRequested = false; }
  };

  document.addEventListener('visitorConsentCollected', (event) => {
    courseMeasurement.consent(event.detail);
    viewportMeasurement.consent(event.detail);
    if (event.detail?.analyticsAllowed === false || event.detail?.marketingAllowed === false) {
      klarnaDeniedLatch = true;
      stopKlarna();
      discardKlarnaPending();
    } else if (event.detail?.analyticsAllowed === true && event.detail?.marketingAllowed === true) {
      klarnaDeniedLatch = false;
    }
    syncConsent(event.detail);
    publishPending();
    courseMeasurement.reconcile();
    viewportMeasurement.start();
  });
  bindInteractions();
  window.addEventListener('pagehide', finishActiveSections);
  window.addEventListener('pagehide', () => { klarnaPageActive = false; stopKlarna(); });
  window.addEventListener('pagehide', () => courseMeasurement.page(false));
  window.addEventListener('pagehide', () => viewportMeasurement.page(false));
  window.addEventListener('pageshow', () => courseMeasurement.page(true));
  window.addEventListener('pageshow', () => viewportMeasurement.page(true));
  window.addEventListener('pageshow', () => { klarnaPageActive = true; syncConsent(); reconcileKlarna(); });
  const tick = () => { loadPrivacy(); syncConsent(); publishPending(); reconcileKlarna(); courseMeasurement.reconcile(); };
  // Continue observing permission/publisher readiness after ten seconds and
  // across late grants. No pre-consent interaction is kept for later replay.
  window.setInterval(tick, 1000);
  tick();
})();
